import { AGENTS } from '../../config/agents';

export type Domain = 'STRATEGY' | 'PEOPLE' | 'PROCESS' | 'TECH' | 'DATA';
export type Quadrant = 'DO' | 'SCHEDULE' | 'DELEGATE' | 'DELETE';
export type EisenboardViewMode = 'board' | 'graph';
export type GraphSearchMode = 'auto' | 'keyword' | 'semantic';
export type GraphRelationType = 'decomposes_to' | 'supports' | 'blocks' | 'related';

export interface FacetRelation {
  targetId: string;
  type: GraphRelationType;
  note?: string;
}

export interface Facet {
  id: string;
  title: string;
  domain: Domain;
  urgency: number;
  importance: number;
  summary: string;
  aiAnalysis: string[];
  relations?: FacetRelation[];
  stratumTags?: string[];
}

export const DOMAIN_TO_STRATUM: Record<Domain, { label: string; short: string; colorClass: string; colorHex: string }> = {
  STRATEGY: { label: 'L4 · Orchestration & Coordination', short: 'L4 · Orchestration', colorClass: 'text-cyan-300',   colorHex: '#67e8f9' },
  PEOPLE:   { label: 'L6 · Governance & Trust',           short: 'L6 · Governance',    colorClass: 'text-pink-300',    colorHex: '#f9a8d4' },
  PROCESS:  { label: 'L4 · Execution Flow',               short: 'L4 · Execution Flow',colorClass: 'text-amber-300',  colorHex: '#fcd34d' },
  TECH:     { label: 'L3 · Execution & Tools',            short: 'L3 · Execution',     colorClass: 'text-violet-300', colorHex: '#c4b5fd' },
  DATA:     { label: 'L2/L5 · Memory & Eval',             short: 'L2/L5 · Memory & Eval', colorClass: 'text-emerald-300', colorHex: '#6ee7b7' },
};

export const DOMAIN_ORDER: Domain[] = ['STRATEGY', 'PEOPLE', 'PROCESS', 'TECH', 'DATA'];

export const COLORS: Record<Domain, string> = {
  STRATEGY: AGENTS.orchestrator.colorHex,
  PEOPLE: AGENTS.people.colorHex,
  PROCESS: AGENTS.process.colorHex,
  TECH: AGENTS.tech.colorHex,
  DATA: AGENTS.data.colorHex,
};

export const clamp = (n: number, min: number, max: number) =>
  Math.max(min, Math.min(max, n));

export const getQuadrant = (u: number, i: number): Quadrant => {
  if (u >= 5 && i >= 5) return 'DO';
  if (u < 5 && i >= 5) return 'SCHEDULE';
  if (u >= 5 && i < 5) return 'DELEGATE';
  return 'DELETE';
};
